import { getDateNum } from 'utils/querySimulation';

export const list = {
	homepage: {
		functionality: 'default',
		buttonDestination: {
			0: 'nextQuestion',
			1: 'destinations',
		},
		shown: false,
	},
	boardingTimes: {
		functionality: 'unordered',
		shown: false,
	},
	travelerNotices: {
		functionality: 'default',
		buttonDestination: {
			0: 'nextQuestion',
			1: 'destinations',
		},
		shown: false,
	},
	stayConnected: {
		functionality: 'default',
		buttonDestination: {
			0: 'close',
		},
		shown: false,
	},
	lostAndFound: {
		functionality: 'default',
		buttonDestination: {
			0: 'close',
		},
		shown: false,
	},
	watchAtHome: {
		functionality: 'default',
		shown: false,
	},
	mushroomKingdom: {
		functionality: 'default',
		buttonDestination: {
			0: 'nextQuestion',
			1: 'destinations',
		},
		shown: false,
	},
	honeyhiveGalaxy: {
		functionality: 'default',
		buttonDestination: {
			0: 'nextQuestion',
			1: 'destinations',
		},
		shown: false,
	},
	fossilFalls: {
		functionality: 'default',
		buttonDestination: {
			0: 'nextQuestion',
			1: 'destinations',
		},
		shown: false,
	},
	cometObservatory: {
		functionality: 'default',
		buttonDestination: {
			0: 'nextQuestion',
			1: 'destinations',
		},
		shown: false,
	},
	dripDropGalaxy: (getDateNum() != '4') && {
		functionality: 'default',
		shown: false,
	},
	tostarenaTown: (getDateNum() === '4') 
		?	{
			functionality: 'default',
			buttonDestination: {
				0: 'nextQuestion',
				1: 'destinations',
			},
			shown: false,
		} 
		: {
			functionality: 'default',
			shown: false,
		}
	,
	spaceJunkGalaxy: {
		functionality: 'default',
		shown: false,
	},
	upWorld: {
		functionality: 'updatesByDate',
		buttonDestination: {
			0: 'airport',
			1: 'airport',
			2: 'airport',
			3: 'airport',
			4: 'ticketSite',
		},
		shown: false,
	},
	downWorld: {
		functionality: 'timeDelayed',
		buttonDestination: {
			0: 'none',
			1: 'leaveDownWorld',
		},
		shown: false,
	},
	boomerang: {
		functionality: 'default',
		shown: false,
	},
	glyph: {
		functionality: 'input',
		shown: false,
	},
};

export const idIndex = {
	boardingTimes: {
		id: 0,
		shown: false
	},
	boardingTimes_routeClosed: {
		id: 1,
		shown: false
	},
};


export const expressionKey = {
	homepage: {
		0: {
			question: 'joy',
			response: 'look'
		},
		1: {
			question: 'look',
			response: 'point'
		}
	},
	boardingTimes: {
		0: {
			question: 'point',
			response: 'wide',
		},
		1: {
			question: 'wide',
		}
	},
	travelerNotices: {
		0: {
			question: 'neutral',
			response: 'look'
		},
		1: {
			question: 'look',
			response: 'point'
		}
	},
	stayConnected: {
		0: {
			question: 'joy',
			response: 'neutral'
		}
	},
	lostAndFound: {
		0: {
			question: 'joy',
			response: 'neutral'
		},
	},
	watchAtHome: {
		0: {
			question: 'joy',
			response: 'neutral'
		},
	},
	mushroomKingdom: {
		0: {
			question: 'wide',
			response: 'look'
		},
		1: {
			question: 'look',
			response: 'point'
		}
	},
	honeyhiveGalaxy: {
		0: {
			question: 'wide',
			response: 'look'
		},
		1: {
			question: 'look',
			response: 'point'
		}
	},
	fossilFalls: {
		0: {
			question: 'wide',
			response: 'neutral'
		},
		1: {
			question: 'look',
			response: 'point'
		}
	},
	cometObservatory: {
		0: {
			question: 'wide',
			response: 'look'
		},
		1: {
			question: 'look',
			response: 'point',
		}
	},
	spaceJunkGalaxy: {
		0: {
			question: 'neutral',
		},
		1: {
			question: 'wide',
		}
	},

	glyph: {
		0: {
			question: 'look'
		},
		1: {
			question: 'joy'
		},
		2: {
			question: 'neutral'
		},
	},
	upWorld: {
		0: {
			question: 'look',
			response: 'neutral'
		},
		1: {
			question: 'point',
			response: 'neutral'
		},
		2: {
			question: 'point',
			response: 'neutral'
		},
		3: {
			question: 'point',
			response: 'neutral'
		},
		4: {
			question: 'joy',
			response: 'neutral'
		},
	},
	downWorld: {
		0: {
			question: 'wide'
		},
		1: {
			question: 'look',
			response: 'wide'
		}
	},
};

export const expressions = {
	neutral: 'fbjxdu',
	joy: 'fbjxdu',
	wide: 'fbjxdu',
	look: 'fbjxdu',
	point: 'fbjxdu'
};